import AreasVertical from '../../components/areasVertical'
import BannerSubhome from '../../components/bannerSubhome'
import Clientes from '../../components/clientes'
import Contato from '../../components/contato'
import Depoimentos from '../../components/depoimentos'
import LinksVertical from '../../components/linksVertical'
import MarcaVertical from '../../components/marcaVertical'
import Marcas from '../../components/marcas'
import Rodape from '../../components/rodape'
import Video from '../../components/video'

function Innovation() {
  return (
    <>
      <Contato />
      <BannerSubhome
        image="banner_innovation.png"
        imageMobile="banner-innovation-mobile.png"
        title="Innovation"
        subtitle={
          <>
            <strong>INTELIGÊNCIA</strong> REAL, <strong>INOVAÇÃO</strong>{' '}
            EXPONENCIAL.
          </>
        }
        marca={{
          color: '#FC0021',
          logoSrc: '../assets/next2ai_logo.svg',
        }}
        hoveredBrand="nex2ai"
        brands={[{ id: 'nex2ai' }]}
      />
      <AreasVertical
        slides={[
          {
            id: 'ia',
            title: 'IA',
            text: (
              <>
                Nossa abordagem em{' '}
                <span className="font-inter-bold">Inteligência Artificial</span>{' '}
                (IA) e <span className="font-inter-bold">Machine Learning</span>{' '}
                (ML) foca em soluções seguras, eficientes e orientadas a{' '}
                <span className="font-inter-bold bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#5534D9] bg-clip-text text-transparent font-bold">
                  resultados de impacto
                </span>{' '}
                para nossos clientes.
              </>
            ),
          },
          {
            id: 'cloud',
            title: 'Cloud',
            text: (
              <>
                Apoiamos a transformação de negócios com{' '}
                <span className="font-inter-bold bg-gradient-to-r from-[#5534D9] via-[#FC0021] to-[#FC0021] bg-clip-text text-transparent font-bold">
                  soluções tecnológicas
                </span>{' '}
                que geram eficiência e <strong>alta performance</strong>.
              </>
            ),
          },
        ]}
        bgColor="bg-gradient-to-r from-[#FC0021] via-[#910CCE] to-[#5534D9]"
      />
      <MarcaVertical
        logoSrc="../assets/next2ai_logo.svg"
        backgroundImage="../assets/next2ai_background.png"
        buttonBgGradient="bg-gradient-to-r from-[#FC0021] via-[#910CCE] to-[#5534D9]"
        infoText={
          <>
            <span className="font-inter-bold">
              Somos especialistas no desenvolvimento de plataformas de gestão de
              dados
            </span>
            , onde a IA otimiza o tempo e eleva a segurança no processamento das
            informações.
          </>
        }
      />
      <LinksVertical
        areasData={[
          {
            icon: '../assets/servicos/ia_icon.png',
            iconHover: '../assets/servicos/ia_icon.png',
            title: 'INTELLIGENCE',
            text: (
              <>
                <div className="flex items-center mb-2">
                  <img
                    src="/assets/arrow.svg"
                    alt="arrow"
                    className="w-6 h-6 mr-2"
                  />
                  <a
                    href="/ia"
                    className="text-white font-inter-regular cursor-pointer hover:underline"
                  >
                    IA
                  </a>
                </div>
                <div className="flex items-center mb-2">
                  <img
                    src="/assets/arrow.svg"
                    alt="arrow"
                    className="w-6 h-6 mr-2"
                  />
                  <a
                    href="/data"
                    className="text-white font-inter-regular cursor-pointer hover:underline"
                  >
                    Data
                  </a>
                </div>
                <div className="flex items-center mb-2">
                  <img
                    src="/assets/arrow.svg"
                    alt="arrow"
                    className="w-6 h-6 mr-2"
                  />
                  <a
                    href="/finep"
                    className="text-white font-inter-regular cursor-pointer hover:underline"
                  >
                    Finep
                  </a>
                </div>
              </>
            ),
            glowColor: '#FC0021',
            url: '/intelligence',
          },
          {
            icon: '../assets/servicos/cloud_icon.png',
            iconHover: '../assets/servicos/cloud_icon.png',
            title: 'CLOUD',
            text: (
              <>
                <div className="flex items-center mb-2">
                  <img
                    src="/assets/arrow.svg"
                    alt="arrow"
                    className="w-6 h-6 mr-2"
                  />
                  <a
                    href="/migracao"
                    className="text-white font-inter-regular cursor-pointer hover:underline"
                  >
                    Migração
                  </a>
                </div>
                <div className="flex items-center mb-2">
                  <img
                    src="/assets/arrow.svg"
                    alt="arrow"
                    className="w-6 h-6 mr-2"
                  />
                  <a
                    href="/devops"
                    className="text-white font-inter-regular cursor-pointer hover:underline"
                  >
                    Devops
                  </a>
                </div>
                <div className="flex items-center mb-2">
                  <img
                    src="/assets/arrow.svg"
                    alt="arrow"
                    className="w-6 h-6 mr-2"
                  />
                  <a
                    href="/finops"
                    className="text-white font-inter-regular cursor-pointer hover:underline"
                  >
                    Finops
                  </a>
                </div>
                <div className="flex items-center mb-2">
                  <img
                    src="/assets/arrow.svg"
                    alt="arrow"
                    className="w-6 h-6 mr-2"
                  />
                  <a
                    href="/seguranca"
                    className="text-white font-inter-regular cursor-pointer hover:underline"
                  >
                    Segurança
                  </a>
                </div>
                <div className="flex items-center mb-2">
                  <img
                    src="/assets/arrow.svg"
                    alt="arrow"
                    className="w-6 h-6 mr-2"
                  />
                  <a
                    href="/monitoramento"
                    className="text-white font-inter-regular cursor-pointer hover:underline"
                  >
                    Monitoramento
                  </a>
                </div>
              </>
            ),
            glowColor: '#FC0021',
            url: '/cloud',
          },
        ]}
      />
      <Video />
      <Marcas />
      <Clientes />
      <Depoimentos />
      <Rodape />
    </>
  )
}

export default Innovation
